import { createUseBottomSheetModal } from '@banhala/ui-kit';
import {
  GoodsParamsContext,
  type GoodsParamsLogging,
} from '../../context/GoodsParamsContext';
import {
  SelectOptionBottomSheetContent,
  type SelectOptionConfirm,
  type SelectOptionParam,
} from './SelectOptionBottomSheet';

type WishlistSelectOptionParam = SelectOptionParam & {
  goodsId: number;
  couponSno?: number;
  logging: GoodsParamsLogging;
};

/**
 * 찜탭(EXP1768 C군)처럼 GoodsDetail route 밖에서 옵션 시트를 단독으로 띄울 때 사용.
 * goodsId/couponSno 를 GoodsParamsContext 로 주입해, modal portal(NavigationContainer
 * 밖) 안의 useGoodsSno/useFixedCouponSno 가 route 없이도 동작하게 한다.
 * logging 을 함께 주입해, PDP 상세 API 없이 카드 데이터로 옵션 시트 로깅을 채운다.
 */
export const useWishlistSelectOptionBottomSheet = createUseBottomSheetModal<
  SelectOptionConfirm,
  WishlistSelectOptionParam
>(({ param, confirm }) => (
  <GoodsParamsContext.Provider
    value={{
      goodsId: param.goodsId,
      couponSno: param.couponSno,
      logging: param.logging,
    }}
  >
    <SelectOptionBottomSheetContent param={param} confirm={confirm} />
  </GoodsParamsContext.Provider>
));
